export const startWorkflow = `
  mutation StartWorkflow($templateName: String!, $input: JSON) {
    startWorkflow(input: { templateName: $templateName, input: $input }) {
      success
      run {
        id
        status
        stepStates { stepId status }
      }
      error
    }
  }
`;

export const cancelWorkflow = `
  mutation CancelWorkflow($runId: String!, $force: Boolean) {
    cancelWorkflow(runId: $runId, force: $force) {
      success
      run { id status }
      error
    }
  }
`;

export const createWorkflowTemplate = `
  mutation CreateWorkflowTemplate($input: CreateWorkflowTemplateInput!) {
    createWorkflowTemplate(input: $input) {
      success
      template { id name }
      error
    }
  }
`;

export const updateWorkflowTemplate = `
  mutation UpdateWorkflowTemplate($id: String!, $input: UpdateWorkflowTemplateInput!) {
    updateWorkflowTemplate(id: $id, input: $input) {
      success
      template { id name version }
      error
    }
  }
`;

export const deleteWorkflowTemplate = `
  mutation DeleteWorkflowTemplate($id: String!) {
    deleteWorkflowTemplate(id: $id) {
      success
      message
      error
    }
  }
`;

export const saveWorkflowYAML = `
  mutation SaveWorkflowYAML($yaml: String!) {
    saveWorkflowYAML(yaml: $yaml) {
      success
      template {
        id
        name
        version
      }
      error
      parseError
      lineNumber
    }
  }
`;

export const reloadWorkflowTemplates = `
  mutation ReloadWorkflowTemplates {
    reloadWorkflowTemplates {
      success
      loadedCount
      error
    }
  }
`;

export const reconcileSchedule = `
  mutation ReconcileSchedule {
    reconcileSchedule {
      success
      schedulesCreated
      schedulesUpdated
      schedulesDeleted
      schedulesUnchanged
      bindingsCreated
      bindingsUpdated
      bindingsDeleted
      bindingsUnchanged
      error
    }
  }
`;
